module.exports = __webpack_public_path__ + "img/university_12.d548d394.png";